import { DataType } from '@miq/catalog';

export const TENANT_SUMMARY_COLUMNS = [
  Object.freeze({
    header: 'Tenant',
    columnId: 90011,
    field: 'tenant',
    path: 'tenant',
    sortable: false,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'Property Type',
    columnId: 90012,
    field: 'propertyType',
    path: 'propertyType',
    sortable: false,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'Floor',
    columnId: 90013,
    field: 'floor',
    path: 'floor',
    sortable: false,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'Suite',
    columnId: 90014,
    field: 'suite',
    path: 'suite',
    sortable: false,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'SF',
    columnId: 90015,
    field: 'sf',
    path: 'sf',
    sortable: false,
    dataType: DataType.Numeric,
  }),
  Object.freeze({
    header: 'Lease Type',
    columnId: 90016,
    field: 'leaseType',
    path: 'leaseType',
    sortable: false,
    dataType: DataType.String,
  }),
  Object.freeze({
    header: 'End Date',
    columnId: 90017,
    field: 'endDate',
    path: 'endDate',
    sortable: false,
    dataType: DataType.String,
  }),
];
